import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const TopServicesLineChart = ({ bookings = [] }) => {
  // Extract & count services
  const serviceCounts = useMemo(() => {
    const counts = {};

    bookings.forEach((booking) => {
      const allServices = [
        ...(booking.selectedBeautyServices || []),
        ...(booking.selectedNailServices || []),
      ];
      allServices.forEach((service) => {
        const title = service.title;
        counts[title] = (counts[title] || 0) + 1;
      });
    });

    return Object.entries(counts)
      .map(([title, count]) => ({ title, count }))
      .sort((a, b) => b.count - a.count) // Top by frequency
      .slice(0, 6); // Top 6
  }, [bookings]);

  const CustomXAxisTick = ({ x, y, payload }) => {
    const words =
      payload.value.length > 12
        ? payload.value.match(/.{1,12}/g) // split every 12 chars
        : [payload.value];
    return (
      <g transform={`translate(${x},${y})`}>
        {words.map((word, index) => (
          <text
            key={index}
            x={0}
            y={index * 12}
            textAnchor="middle"
            fill="#fed693"
            fontSize={10}
          >
            {word}
          </text>
        ))}
      </g>
    );
  };

  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={serviceCounts}
          margin={{ top: 10, right: 20, bottom: 20, left: 10 }} // increased bottom
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="title"
            interval={0}
            tick={CustomXAxisTick}
            stroke="#fed693"
          />
          <YAxis stroke="#fed693" />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#fed693"
            strokeWidth={2}
            dot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopServicesLineChart;
